import React from 'react';
import PropTypes from 'prop-types';

import { useConfig } from '@xingternal/hops';
import { Redirect } from 'react-router-dom';
import queryString from 'query-string';

const matchFaqByExternalUrl = (externalUrl) => {
  if (/preview.xing.com|kenv.xing.com/.test(externalUrl)) {
    return 'https://preview-faq-drupal8.xing.com';
  }

  return 'https://faq.xing.com';
};

const validRedirectUrl = (url) => url.startsWith('/de') || url.startsWith('/en');

const findFaqUrl = (faqUrl, hopsConfig) => {
  const faqHost = matchFaqByExternalUrl(hopsConfig.externalUrl);
  if (!faqUrl) {
    return faqHost;
  }

  if (validRedirectUrl(faqUrl) || validRedirectUrl(encodeURIComponent(faqUrl))) {
    return `${faqHost}${faqUrl}`;
  }

  return faqHost;
};

const HelpSupport = ({ location: { search } }) => {
  const hopsConfig = useConfig();

  const queryParams = queryString.parse(search);
  const faqUrl = findFaqUrl(queryParams.faq_url, hopsConfig);

  return <Redirect to={faqUrl} />;
};

HelpSupport.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};

export default HelpSupport;
